const FORM_TYPE = {
  Login: 'login',
  ForgotPassword: 'forgotPassword',
};

export default FORM_TYPE;
